import * as React from 'react';

const GridChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="grid-chunky_svg__eds-icon--grid-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="grid-chunky_svg__eds-icon--grid-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 20h4v-4h-4v4zm0-6h4v-4h-4v4zm-6-6h4V4h-4v4zm6-4v4h4V4h-4zm-6 10h4v-4h-4v4zm-6 0h4v-4H4v4zm0 6h4v-4H4v4zm6 0h4v-4h-4v4zM4 8h4V4H4v4z"
        />
    </svg>
);

GridChunkySvg.displayName = 'GridChunkySvg';
export default GridChunkySvg;
